import {createI18nScope} from 'common/i18n/scope';

export default createI18nScope(`common.widgets.date-range-picker-new`, {
  'common.advanced': `Advanced`,
  'common.apply': `Apply`,
  'common.cancel': `Cancel`,
  'common.custom': `Custom`,
  'common.upgrade': `Upgrade`,
  'reports.date-range.custom.advanced-options': `$t(common.advanced)`,
  'reports.date-range.custom.advanced.disable-time-ranges': `Disable Time Ranges`,
  'reports.date-range.custom.advanced.enable-time-ranges': `Enable Time Ranges`,
  'reports.date-range.custom.date-placeholder': `Describe a date`,
  'reports.date-range.custom.duration-ago': `{{duration}} ago`,
  'reports.date-range.custom.end': `End`,
  'reports.date-range.custom.ending-date': `Ending`,
  'reports.date-range.custom.mode.between': `Fixed`,
  'reports.date-range.custom.mode.in-the-last': `Last`,
  'reports.date-range.custom.mode.on': `On`,
  'reports.date-range.custom.mode.since': `Since`,
  'reports.date-range.custom.since-date-placeholder': `Since date`,
  'reports.date-range.custom.start': `Start`,
  'reports.date-range.custom.time-placeholder': `Time`,
  'reports.date-range.custom.tooltip.change-unit': `Change {{units}} to days to select ending date`,
  'reports.date-range.custom.tooltip.change-unit-warning': `Changing the unit from "days" will remove the ending date`,
  'reports.date-range.custom.tooltip.history-limit': `Upgrade your plan to query more than {{count}} days of data.`,
  'reports.date-range.custom.tooltip.time-limit': `Time window may be up to {{count}} days ago.`,
  'reports.date-range.custom.value-placeholder': `Enter a value`,
  'reports.date-range.display-label.between': `Between {{fromDate}} — {{toDate}}`,
  'reports.date-range.display-label.ending': `ending {{date}}`,
  'reports.date-range.display-label.ending-ago': `ending {{value}} {{unit}} ago`,
  'reports.date-range.display-label.in-the-last': `In the last {{value}} {{unit}}`,
  'reports.date-range.display-label.last': `Last {{value}} {{unit}}`,
  'reports.date-range.display-label.since': `Since {{date}}`,
  'reports.date-range.exclusion.custom.selected-label': `Excluding last {{value}} {{unit}}`,
  'reports.date-range.invalid.last-non-integer-input': `Input must be an integer`,
  'reports.date-range.invalid.last-range-max': `Value exceeds {{max}} {{unit}} maximum`,
  'reports.date-range.invalid.last-range-min': `Value below {{min}} {{unit}} minimum`,
});
